import {createLogger} from '~/shared/logging';

import {Coordinate, SerializedCoordinate} from './types';

import LatLng = google.maps.LatLng;

const logger = createLogger('Maps/utils');

const INNER_MAP_WIDTH_PADDING_MOBILE = 20;
const INNER_MAP_WIDTH_PADDING_DESKTOP = 60;
const INNER_MAP_HEIGHT_PADDING_MOBILE = 80;
const INNER_MAP_HEIGHT_PADDING_DESKTOP = 80;

export const serializeCoordinate = (coordinate: Coordinate): SerializedCoordinate => ({
  lat: coordinate.latitude,
  lng: coordinate.longitude,
});

export const compareCoordinates = (a: Coordinate | SerializedCoordinate, b: Coordinate | SerializedCoordinate): boolean => {
  if (!a || !b) {
    return false;
  }

  const latA = 'latitude' in a ? a.latitude : a.lat;
  const lngA = 'longitude' in a ? a.longitude : a.lng;

  const latB = 'latitude' in b ? b.latitude : b.lat;
  const lngB = 'longitude' in b ? b.longitude : b.lng;

  return latA === latB && lngA === lngB;
};

export const adjustCenterAndZoom = ({
  map,
  serviceCoordinate,
  userLocation,
  innerMapPadding,
  maxZoom,
}: {
  map: google.maps.Map;
  serviceCoordinate: Coordinate;
  userLocation?: Coordinate;
  innerMapPadding: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
  maxZoom?: number;
}) => {
  const bounds = new google.maps.LatLngBounds();
  bounds?.extend({lat: serviceCoordinate.latitude, lng: serviceCoordinate.longitude});
  if (userLocation) {
    bounds?.extend({lat: userLocation.latitude, lng: userLocation.longitude});
  }
  map.fitBounds(bounds, innerMapPadding);
  if (maxZoom) {
    const currentZoom = map.getZoom() || maxZoom;
    map.setZoom(currentZoom > maxZoom ? maxZoom : currentZoom);
  }
};

export const getInnerMapPadding = (isMinLargeMobile: boolean): {
  top: number;
  bottom: number;
  left: number;
  right: number;
} => ({
  top: isMinLargeMobile ? INNER_MAP_HEIGHT_PADDING_DESKTOP : INNER_MAP_HEIGHT_PADDING_MOBILE,
  bottom: isMinLargeMobile ? INNER_MAP_HEIGHT_PADDING_DESKTOP : INNER_MAP_HEIGHT_PADDING_MOBILE,
  left: isMinLargeMobile ? INNER_MAP_WIDTH_PADDING_DESKTOP : INNER_MAP_WIDTH_PADDING_MOBILE,
  right: isMinLargeMobile ? INNER_MAP_WIDTH_PADDING_DESKTOP : INNER_MAP_WIDTH_PADDING_MOBILE,
});

export const mapGoogleLatLngToCoordinate = (coordinate: LatLng | undefined): Coordinate | null => {
  if (!coordinate) {
    logger.log('No coordinate provided to mapGoogleLatLngToCoordinate');
    return null;
  }
  return {
    latitude: coordinate.lat(),
    longitude: coordinate.lng(),
  };
};
